(function () {
  'use strict';
  angular.module('common')
    .component('taxIdGrid', {
        bindings: {
          model: '=',
          readOnly: '@',
          disableAdd: '=',
          validateUnique: '@',
          skipTaxIdCheck: '@',
          dsoId: '@',
          showDuplicateError: '@',
          inUserView: '=',
          isTaxIdApprover: '@',
          isRegistrationMode: '@'
        },
        controller: ['$scope', '$filter', '$uibModal', 'Dso', 'uiGridConstants', '$window', 'MyDso',
          function ($scope, $filter, $uibModal, Dso, uiGridConstants, $window, MyDso) {
          var ctrl = this;
          ctrl.sortByStatus = false;
          ctrl.taxIdGridOptions = {
            enableSorting: true,
            enableColumnResizing: true,
            enableRowHeaderSelection: false,
            exporterMenuPdf: false,
            enableGridMenu: true,
            onRegisterApi: function(api) {
              ctrl.taxIdGridApi = api;
            },
            appScopeProvider: {
              deleteRow : (row) => {
                ctrl.taxIdGridApi.selection.selectRow(row);
                ctrl.confirmApproveReject(row, 'Delete');
              },
              approveTaxId : (row) => {
                ctrl.confirmApproveReject(row, 'Approve');
              },
              rejectTaxId : (row) => {
                ctrl.confirmApproveReject(row, 'Reject');
              }
            }
          };
          ctrl.pushTaxIdToGrid = function(newTaxId){
            if(ctrl.isRegistrationMode){
              newTaxId = {taxId: newTaxId};
            }
            ctrl.model.push(newTaxId);
            ctrl.taxIds.push(newTaxId.taxId);
            ctrl.taxId='';
          };
          ctrl.addTaxId = function() {
            if ($scope.taxIdGridForm.taxId.$valid && ctrl.taxId) {
              if(ctrl.isRegistrationMode){
                ctrl.pushTaxIdToGrid(ctrl.taxId);
              } else {
                ctrl.running = true;
                let taxId = ctrl.isTaxIdApprover ? {'taxId': ctrl.taxId, 'id': ctrl.dsoId} : {'taxId':  ctrl.taxId};
                ctrl.dsoFactory.addTaxId(taxId, function(newTaxId) {
                  ctrl.running = false;
                  ctrl.pushTaxIdToGrid(newTaxId);
                  $scope.dnConfirmationMessage.$show("Tax ID "+ $filter('taxId')(newTaxId.taxId) +" has been added.");
                },function(error) {
                  ctrl.running = false;
                  throw error;
                });
              }
            }
          };
          ctrl.popTaxIdFromGrid = function(row){
            ctrl.taxIdGridOptions.data.splice(ctrl.taxIdGridOptions.data.indexOf(row.entity),1);
            ctrl.taxIds.splice(ctrl.taxIds.indexOf(row.entity.taxId),1);
          };
          ctrl.removeTaxId = function(row) {
            if(ctrl.isRegistrationMode){
              ctrl.popTaxIdFromGrid(row);
            } else {
              ctrl.running = true;
              ctrl.taxId='';
              let taxId = ctrl.isTaxIdApprover ? {'taxId': row.entity.taxId, 'id': ctrl.dsoId} : {'taxId': row.entity.taxId};
              ctrl.dsoFactory.deleteTaxId(taxId, function() {
                ctrl.running = false;
                ctrl.popTaxIdFromGrid(row);
                $scope.dnConfirmationMessage.$show("Tax ID "+ $filter('taxId')(row.entity.taxId) +" has been deleted.");
              }, function(error) {
                ctrl.running = false;
                throw error;
              });
            }
          };
          ctrl.confirmApproveReject = function(row,action) {
            if (action == 'Approve' || action == 'Reject' || action == 'Delete') {
              $uibModal.open({
                controller:['$uibModalInstance', 'taxIdInfo', '$scope', function($uibModalInstance, taxIdInfo, $scope) {
                  var self = this;
                  self.taxIdInfo = angular.copy(taxIdInfo);
                  self.action = action;
                  $scope.$on('authenticationChanged', () => {
                    $uibModalInstance.dismiss();
                  });
                  self.approveReject = function() {
                    $uibModalInstance.close({action: self.action, taxId: self.taxIdInfo.row, dsoId: self.taxIdInfo.dsoId });
                  };
                  self.close = function() {
                    $uibModalInstance.dismiss();
                  };
                }],
                templateUrl: '/js/common/taxIdApproveRejectConfirmation.html' + appVersion,
                size: 'sm',
                animation: false,
                controllerAs: 'confirmation',
                resolve: {
                  taxIdInfo: function() {
                    return {
                      dsoId: ctrl.dsoId,
                      inUserView: ctrl.inUserView,
                      row: row.entity
                    };
                  }
                }
              }).result.then(function(result) {
                switch (result.action) {
                  case 'Approve':
                    Dso.approveTaxId({id: result.dsoId, taxId: result.taxId},function(taxId) {
                      ctrl.taxIdGridOptions.data[_.findIndex(ctrl.taxIdGridOptions.data, (t) => {
                        return t.id == taxId.id && t.taxId === taxId.taxId;})] = taxId;
                    });
                    break;
                  case 'Reject':
                    Dso.rejectTaxId({id: result.dsoId, taxId: result.taxId},function(taxId) {
                      ctrl.taxIdGridOptions.data[_.findIndex(ctrl.taxIdGridOptions.data, (t) => {
                        return t.id == taxId.id && t.taxId === taxId.taxId;})] = taxId;
                    });
                    break;
                  case  'Delete':
                    ctrl.removeTaxId(row);
                    break;
                }
              }, angular.noop);
            }
          };
          this.$doCheck = function() {
        	if (ctrl.model != ctrl.oldModel) {
              ctrl.taxIdGridOptions.data = ctrl.model;
              ctrl.taxIds = _.map(ctrl.model,'taxId');
              ctrl.oldModel = ctrl.model;
            }
          };
          this.$onInit = function() {
            ctrl.oldModel = ctrl.model;
            ctrl.taxIdGridOptions.data = ctrl.model;
            ctrl.taxIds = _.map(ctrl.model,'taxId');
            ctrl.dsoErrorMsg = "";
            ctrl.dsoExists = false;
            ctrl.dsoFactory = ctrl.isTaxIdApprover ? Dso : MyDso();
            ctrl.taxIdGridOptions.columnDefs = [
              { field: 'taxId', displayName: 'Tax ID', width: '20%',
                sort: { priority: 1 }, cellFilter: 'taxId'},
              { field: 'status', displayName: 'Status', width: '55%',
                cellFilter: ctrl.showDuplicateError ? 'taxIdValidationStatus:row.entity' : 'taxIdStatus:row.entity', 
                sortingAlgorithm: sortStatus(ctrl.showDuplicateError ?  $filter('taxIdValidationStatus'): $filter('taxIdStatus'))
              }
            ];
            if (ctrl.readOnly == 'true') {
              if (_.find(ctrl.model, function(taxId) { return taxId.status === 'PENDING_TIN_APPROVAL';})) {
                ctrl.taxIdGridOptions.columnDefs.push({ name: 'Approve/Reject',
                    cellTemplate: '<span class="multiTaxId" ng-show="row.entity.status==\'PENDING_TIN_APPROVAL\'">&nbsp; ' +
                                    '<a href ng-click="grid.appScope.approveTaxId(row)" ng-show="(row.entity.status | taxIdValidationStatus:row.entity) == \'Valid\'">' +
                                      '<i class="fa fa-check-circle fa-lg" aria-hidden="true" title="Approve"></i></a> &nbsp;&nbsp;' +
                                    '<a href ng-click="grid.appScope.rejectTaxId(row)"><i class="fa fa-times-circle fa-lg" aria-hidden="true" title="Reject"></i></a>' +
                                    '</span>',
                    sort: { direction:uiGridConstants.DESC, priority: 0 },
                    sortingAlgorithm: approveRejectSort
                });
              }
            }else{
                var showHideClause = !ctrl.isRegistrationMode ? ' ng-show="grid.rows.length > 1"' : ' ';
                ctrl.taxIdGridOptions.columnDefs.push({ name: 'Delete',
                    cellTemplate: '<span class="multiTaxId" ' + showHideClause
                    + '><a href ng-click="grid.appScope.deleteRow(row)"><i class="fa fa-minus-circle fa-lg" aria-hidden="true"></i></a></span>' });
            }
            $scope.$watch('errorControl', function() {
              $scope.errorControl && $scope.errorControl.showErrors(['uniqueList','taxId','duplicateDsoTaxId', 'duplicateProviderTaxId']);
            });
          };
          function approveRejectSort(a,b,rowA,rowB) {
            var rank = { 'APPROVED': 1, 'REJECTED': 2, 'PENDING_TIN_APPROVAL' : 3 };
            if (rank[rowA.entity.status] < rank[rowB.entity.status]) {
                return -1;
            } else if (rank[rowA.entity.status] > rank[rowB.entity.status]) {
                return 1;
            } else {
                return 0;
            }
          }
          var sortStatus = _.curry(function sortStatus(displayFn, a,b,rowA,rowB) {
            var x = displayFn(a,rowA.entity);
            var y = displayFn(b,rowB.entity);

            if(x < y) {
              return -1;
            } else if(x == y) {
              return 0;
            } else {
              return 1;
            }
          });
        }],
        templateUrl: '/js/common/taxIdGrid.html' + appVersion
      }
    );
})();
